import React from "react";
import { connect } from "react-redux";
import Rdx from "../../../../src/redux/Rdx";
import ReactToggle from "react-toggle";
import "react-toggle/style.css";

import Context from "../../../context/Context";
import * as component from "../../util/component";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import { Topic } from "../../../util/tsUtil";
import HelpTip from "../../common/HelpTip/HelpTip";
import FieldNames from "../../../aiim/datasets/FieldNames";
import Office365 from "../More/Actions/BookWorkspace/WorkspaceReservation/Office365";

//Calcite
import Checkbox from "calcite-react/Checkbox";
import TextField from 'calcite-react/TextField';
import { FormControlLabel } from 'calcite-react/Form'

const CSS = {
  section: "i-form-group i-section",
  formGroup: "i-form-group",
  formGroupHeader: "i-form-group-header",
  formGroupName: "i-form-group-name",
  toggleLabel: "i-toggle-label",
  sidebarPanelOpen: "i-sidebar-panel-open"
};

class OfficeHoteling extends React.Component {

  _mounted = false;
  isErrors = false;

  workspaceInfo = null;

  constructor(props) {
    super(props);
    const workspaceReservation = this.props.cfg.getConfigurable("workspaceReservation");
    this.workspaceInfo = this.getWorkspaceInfo();
    this.state = component.newState({
      enabled: !!workspaceReservation.enabled,
      appId: workspaceReservation.appId,
      tenantId: workspaceReservation.tenantId,
      isSingleTenant: workspaceReservation.isSingleTenant,
      optionSelected: workspaceReservation.reservationType,
      reservationsLyrId: workspaceReservation.reservationLayerId,
      hotelBookingOffice365: workspaceReservation.enableOfficeHoteling,
      hotelBooking: workspaceReservation.enableOfficeHoteling,
      meetingRooms: workspaceReservation.enableMeetingRooms,
      isLayerEditable: false,
      canUserEdit: false,
      hasReservationsLayer: false,
      //unitHasAreaId: false,
      //unitHasReservationMethod: false
    });
  }

  componentDidMount() {
    this._mounted = true;

    Topic.subscribe(Topic.ViewsReloaded, ()=> {
      this.workspaceInfo = this.getWorkspaceInfo();
      this.init("viewsReloaded");
    })

    this.init("componentMounted");
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
    this._mounted = false;
  }

  closeBookWorkspacePanel(activeKey) {
    if(!activeKey || (activeKey && activeKey === this.props.rdxSidebarActiveKey)) {
      Rdx.setValue(this, Rdx.Keys.SIDEBAR_ACTIVE_KEY, null);
      document.body.classList.remove(CSS.sidebarPanelOpen);
      Context.instance.views.toggleClickHandlers("resume");
    }
  }

  getWorkspaceInfo() {
    let wsCfg = this.props.cfg.getConfigurable("workspaceReservation");
    let wsInfo = {
      canAutoEnableReservations: false,
      canUserEdit: false,
      isEditable: false,
      hasReservationsLayer: false,
      reservationLayerId: null,
      reservationsLyrTitle: null,
      hasUnitsLayer: null,
      unitsHasAreaId: false,
      unitsHasReservationMethod: false,
      unitsHasScheduleEmail: false
    }
    const view = Context.instance.views.mapView;
    const layers = aiimUtil.getLayers(view).items;

    const units = Context.instance.aiim.datasets && Context.instance.aiim.datasets.units;
    const unitsLayer = units && units.layer2D;
    const unitsFields = unitsLayer && unitsLayer.fields;
    wsInfo.hasUnitsLayer = !!unitsLayer;
    wsInfo.unitsHasAreaId = !!aiimUtil.findField(unitsFields,FieldNames.UNITS_AREA_ID);
    wsInfo.unitsHasReservationMethod = !!aiimUtil.findField(unitsFields,FieldNames.RESERVATION_METHOD);
    wsInfo.unitsHasScheduleEmail = !!aiimUtil.findField(unitsFields,FieldNames.SCHEDULE_EMAIL);

    let reservationsLayer;
    let layerId = wsCfg.reservationLayerId;
    if (layerId) {
      if (this.hasReservationsLayer(layerId)) {
        reservationsLayer = view.map.findLayerById(layerId);
      }
    }
    if (!reservationsLayer) {
      reservationsLayer = this.findReservationsLayer(layers);
    }
    if (reservationsLayer) {
      wsInfo.isEditable = this.isLayerEditable(reservationsLayer);
      wsInfo.canUserEdit = this.canUserEdit();
      wsInfo.hasReservationsLayer = true;
      wsInfo.reservationLayerId = reservationsLayer.id;
      wsInfo.reservationsLyrTitle = reservationsLayer.title;
    }

    if (reservationsLayer && wsInfo.isEditable && wsInfo.canUserEdit &&
        wsInfo.unitsHasAreaId && (wsInfo.unitsHasReservationMethod || wsInfo.unitsHasScheduleEmail)) {
      wsInfo.canAutoEnableReservations = true;
    }
    return wsInfo;
  }

  init = (initType) => {
    // initType "componentMounted" | "enableWorkspaceReservarionClicked" | "viewsReloaded"
    const wsCfg = this.props.cfg.getConfigurable("workspaceReservation");
    const wsInfo = this.workspaceInfo || {};

    let stateParams = {
      reservationsLyrId : wsInfo.reservationLayerId,
      reservationsLyrTitle: wsInfo.reservationsLyrTitle,
      isLayerEditable: wsInfo.isEditable,
      canUserEdit: wsInfo.canUserEdit,
      hasReservationsLayer: wsInfo.hasReservationsLayer,
      optionSelected : null,
      hotelBookingOffice365: false,
      hotelBooking: false,
      meetingRooms: false
    }

    let viewsReloaded = initType === "viewsReloaded";
    if(viewsReloaded) {
      if (wsCfg.enabled && wsCfg.reservationType === "esri") {
        if (!wsInfo.canAutoEnableReservations) {
          wsCfg.reservationType = "office365";
        }
      }
    }

    if (wsCfg.enabled && wsCfg.reservationType === "office365") {
      this.whenByOffice365Activated(stateParams,initType);
    } else if (wsCfg.enabled && wsCfg.reservationType === "esri") {
      this.whenByReservationsLayerActivated(stateParams,initType);
    } else if (wsInfo.canAutoEnableReservations) {
      if(initType === "componentMounted") {
        if(!Context.instance.session.appDataHadWorkspaceConfig) {
          this.whenByReservationsLayerActivated(stateParams,initType);
        }
      } else {
        this.whenByReservationsLayerActivated(stateParams,initType);
      }
    } else {
      if(initType === "enableWorkspaceReservarionClicked") {
        this.whenByOffice365Activated(stateParams,initType)
      }
    }

    this.setState(stateParams);
    setTimeout(()=> {
      Topic.publish(Topic.ReloadWorkspace, {});
    }, 1);
  }

  _init=(forReloadView)=> {
    if (!this._mounted) return;

    const workspaceResConfig = this.props.cfg.getConfigurable("workspaceReservation");
    let autoEnable = false;

    const view = Context.getInstance().views.mapView;
    let layerId ,isEditable = true, canUserEdit = true, hasReservationsLayer = false,
        reservationsLayer, reservationsLyrTitle;

    let enableOfficeHoteling = false, enableMeetingRooms = false, hotelBookingOffice365 = false;
    Context.instance.session.invalidWorkspaceConfig = false;

    if(workspaceResConfig && workspaceResConfig.reservationType === "office365" &&
      workspaceResConfig.appid) {
      hotelBookingOffice365 = true;
    }

    if(workspaceResConfig && workspaceResConfig.reservationType === "office365" &&
      !workspaceResConfig.appid) {
        hotelBookingOffice365 = true;
        Context.instance.session.invalidWorkspaceConfig = true;
      }

    const reservationLayerId = workspaceResConfig && workspaceResConfig.reservationLayerId;
    // if reservation layer id is present; check if the layerid gives a valid reservations layer
    if(reservationLayerId) {
      layerId = this.props.cfg.getConfigurable("workspaceReservation").reservationLayerId;
      if(layerId) {

        reservationsLayer = view.map.findLayerById(layerId);
        // if layerId found does not give a valid reservation layer set layerId to null

        if(!reservationsLayer) layerId = null;
        if(reservationsLayer) {
          reservationsLyrTitle = reservationsLayer.title;
          hasReservationsLayer = this.hasReservationsLayer(layerId);
          isEditable = this.isLayerEditable(reservationsLayer);
          canUserEdit = this.canUserEdit();
          enableOfficeHoteling = workspaceResConfig.enableOfficeHoteling;
          enableMeetingRooms = workspaceResConfig.enableMeetingRooms;
        }

        this.props.cfg.getConfigurable("workspaceReservation").enableMeetingRooms = enableMeetingRooms;
        this.props.cfg.getConfigurable("workspaceReservation").enableOfficeHoteling = enableOfficeHoteling;
        this.props.cfg.getConfigurable("workspaceReservation").reservationLayerId = layerId;
        this.props.cfg.getConfigurable("workspaceReservation").reservationType = "esri";
        this.props.cfg.getConfigurable("workspaceReservation").appId = null;
        this.props.cfg.getConfigurable("workspaceReservation").isSingleTenant = false;
        this.props.cfg.getConfigurable("workspaceReservation").tenantId = null;
      }
    }

    // if no reservations layer or workspaceResConfig.reservationLayerId is null
    if(!hotelBookingOffice365 &&
      (!layerId || (workspaceResConfig && !workspaceResConfig.reservationLayerId))) {
      const layers = aiimUtil.getLayers(view).items;
      // find a reservations layer
      const reservationLyr = this.findReservationsLayer(layers);
      // find a units layer
      const isUnitsLayer = this.isUnitsLayer();

      // retrive values from reservations layer to set in the state
      if(reservationLyr) {
        layerId = reservationLyr.id;
        reservationsLyrTitle = reservationLyr.title;
        hasReservationsLayer = true;
      }

      //check for validations on reservations layer
      if(hasReservationsLayer) {
        // check if reservations layer is editable
        isEditable = this.isLayerEditable(reservationLyr);
        canUserEdit = this.canUserEdit();
      }

      // if reservations layer is not found; let the default section be office365
      if(!hasReservationsLayer) {
        Context.instance.session.invalidWorkspaceConfig = true;
        this.props.cfg.getConfigurable("workspaceReservation").reservationType = "office365";
        this.props.cfg.getConfigurable("workspaceReservation").reservationLayerId = null;
      }

      // if reservations layer is found; set values in the configurator
      if(hasReservationsLayer) {
        this.props.cfg.getConfigurable("workspaceReservation").reservationLayerId = layerId;
        this.props.cfg.getConfigurable("workspaceReservation").reservationType = "esri";

        // if reservations layer is not editable or user cannot edit the layer, keep the
        // officehoteling and meeting rooms unchecked by default
        if(!isEditable || !canUserEdit) {
          Context.instance.session.invalidWorkspaceConfig = true;
          this.props.cfg.getConfigurable("workspaceReservation").enableOfficeHoteling = false;
          this.props.cfg.getConfigurable("workspaceReservation").enableMeetingRooms = false;
        }
      }


      if(hasReservationsLayer && isUnitsLayer && isEditable && canUserEdit ) {
        const unitHasAreaId = this.unitLyrHasAreaID();
        const unitHasReservationMethod = this.unitLyrHasReservationMethod();

        // area_id and reservation method are required fields for meeting rooms
        // area_id is required field for hotels
        if(unitHasAreaId && unitHasReservationMethod) {
          autoEnable = true;
          enableOfficeHoteling = true;
          enableMeetingRooms = true;
        }else if (unitHasAreaId && !unitHasReservationMethod) {
          autoEnable = true;
          enableOfficeHoteling = true;
          enableMeetingRooms = false;
        } else {
          // if both area_id and reservations method are not there set to invalidConfiguration
          Context.instance.session.invalidWorkspaceConfig = true;
          enableOfficeHoteling = false;
          enableMeetingRooms = false;
        }

        // set changes in the configuration
        this.props.cfg.getConfigurable("workspaceReservation").enableMeetingRooms = enableMeetingRooms;
        this.props.cfg.getConfigurable("workspaceReservation").enableOfficeHoteling = enableOfficeHoteling;
        this.props.cfg.getConfigurable("workspaceReservation").reservationLayerId = layerId;
        this.props.cfg.getConfigurable("workspaceReservation").reservationType = "esri";
        this.props.cfg.getConfigurable("workspaceReservation").appId = null;
        this.props.cfg.getConfigurable("workspaceReservation").isSingleTenant = false;
        this.props.cfg.getConfigurable("workspaceReservation").tenantId = null;
      }

      if(autoEnable && forReloadView) {
        this.setState(() => {
          return {
            enabled: true
          }
        });
        this.props.cfg.getConfigurable("workspaceReservation").enabled = true;
        Topic.publish(Topic.ReloadWorkspace, {});
      }
      if(!autoEnable && forReloadView) {
        this.setState(() => {
          return {
            enabled: false
          }
        });
        this.props.cfg.getConfigurable("workspaceReservation").enabled = false;
        Topic.publish(Topic.ReloadWorkspace, {});
      }
    }

    if(hotelBookingOffice365 &&
      (!layerId || (workspaceResConfig && !workspaceResConfig.reservationLayerId))) {
      const layers = aiimUtil.getLayers(view).items;
      // find a reservations layer
      const reservationLyr = this.findReservationsLayer(layers);
      // find a units layer
      const isUnitsLayer = this.isUnitsLayer();

      // retrive values from reservations layer to set in the state
      if(reservationLyr) {
        layerId = reservationLyr.id;
        reservationsLyrTitle = reservationLyr.title;
        hasReservationsLayer = true;
      }

      //check for validations on reservations layer
      if(hasReservationsLayer) {
        // check if reservations layer is editable
        isEditable = this.isLayerEditable(reservationLyr);
        canUserEdit = this.canUserEdit();
      }
    }

    this.setState({
      reservationsLyrId : layerId,
      reservationsLyrTitle: reservationsLyrTitle,
      optionSelected : this.props.cfg.getConfigurable("workspaceReservation").reservationType,
      isLayerEditable: isEditable,
      canUserEdit: canUserEdit,
      hasReservationsLayer: hasReservationsLayer,
      hotelBookingOffice365: hotelBookingOffice365,
      hotelBooking: enableOfficeHoteling,
      meetingRooms: enableMeetingRooms
    })
    //}
    setTimeout(()=> {Topic.publish(Topic.RenderSidebar, {});}, 1);
  }

  // check if the user has an edit privilege
  canUserEdit=()=>{
    const user = Context.getInstance().user;
    if(!user) return false;

    return (user.isAdmin() || user.isPublisher() || user.isDataEdit() || user.isFullDataEdit());
  }

  // check if editing option on the layer has beeen enabled
  isLayerEditable=(reservationsLayer)=>{
    if(!reservationsLayer) return false;

    if(reservationsLayer.type !== "feature") return false;

    // check if add and update operations are enabled
    const editingEnabled = reservationsLayer.editingEnabled;
    const supportedOperations = reservationsLayer.capabilities && reservationsLayer.capabilities.operations;
    const supportsAdd = supportedOperations && supportedOperations.supportsAdd;
    const supportsUpdate = supportedOperations && supportedOperations.supportsUpdate;
    const supportsDelete = supportedOperations && supportedOperations.supportsDelete;
    const supportsRequiredOperations = supportsAdd && supportsUpdate && supportsDelete;

    if(editingEnabled && supportsRequiredOperations) return true;
    return false;
  }

  // findUnitsLayer=(layers)=> {
  //   if(!layers) return;
  //   for(let i=0;i<layers.length;i++) {
  //     const fields = layers[i].fields;
  //     if(aiimUtil.findField(fields,FieldNames.UNIT_ID)) return layers[i];
  //   }
  // }

  // return a reservations layer
  findReservationsLayer=(layers)=>{
    if(!layers) return;

    for(let i=0;i<layers.length;i++) {
      const fields = layers[i].fields;
      const levelIdField = Context.instance.aiim.getLevelIdField(layers[i]);

      if(layers[i].geometryType === "point") {}
      else {
        if(aiimUtil.findField(fields,FieldNames.RESERVED_FOR_USERNAME) &&
            aiimUtil.findField(fields,FieldNames.RESERVED_FOR_FULL_NAME) &&
            aiimUtil.findField(fields,FieldNames.STATE) &&
            aiimUtil.findField(fields,FieldNames.START_TIME) &&
            aiimUtil.findField(fields,FieldNames.END_TIME) &&
            aiimUtil.findField(fields,FieldNames.CHECK_IN_TIME) &&
            aiimUtil.findField(fields,FieldNames.CHECK_OUT_TIME) &&
            aiimUtil.findField(fields,FieldNames.TITLE) &&
            aiimUtil.findField(fields, FieldNames.ALL_DAY) &&
            aiimUtil.findField(fields,FieldNames.DESCRIPTION) &&
            aiimUtil.findField(fields,FieldNames.UNIT_ID) &&
            aiimUtil.findField(fields,FieldNames.UNIT_NAME) && levelIdField) {
          return layers[i];
        }
      }
    }
  }

  //check if the layer has all required fields needed for a reservations layer
  hasReservationsLayer=(layerId)=>{
    let layer;
    const view = Context.getInstance().views.mapView;
    if(view) layer = view.map.findLayerById(layerId);
    if(!layer) return false;

    const fields = layer.fields;
    const levelIdField = Context.instance.aiim.getLevelIdField(layer);

    if(aiimUtil.findField(fields,FieldNames.RESERVED_FOR_USERNAME) &&
      aiimUtil.findField(fields,FieldNames.RESERVED_FOR_FULL_NAME) &&
      aiimUtil.findField(fields,FieldNames.STATE) &&
      aiimUtil.findField(fields,FieldNames.START_TIME) &&
      aiimUtil.findField(fields,FieldNames.END_TIME) &&
      aiimUtil.findField(fields,FieldNames.CHECK_IN_TIME) &&
      aiimUtil.findField(fields,FieldNames.CHECK_OUT_TIME) &&
      aiimUtil.findField(fields,FieldNames.TITLE) &&
      aiimUtil.findField(fields, FieldNames.ALL_DAY) &&
      aiimUtil.findField(fields,FieldNames.DESCRIPTION) &&
      aiimUtil.findField(fields,FieldNames.UNIT_ID) &&
      aiimUtil.findField(fields,FieldNames.UNIT_NAME) && levelIdField) {
        return true;
      }
    return false;
  }

  isUnitsLayer=()=>{
    const units = Context.instance.aiim.datasets && Context.instance.aiim.datasets.units;
    if(!units) return false;

    const layer = units.layer2D;
    if(!layer) return false;

    return true;
  }

  unitLyrHasAreaID =()=> {
    const units = Context.instance.aiim.datasets && Context.instance.aiim.datasets.units;
    if(!units) return false;

    const layer = units.layer2D;
    if(!layer) return false;

    const fields = layer.fields;
    if(aiimUtil.findField(fields,FieldNames.UNITS_AREA_ID)) return true;
    return false;
  }

  unitLyrHasReservationMethod =()=> {
    const units = Context.instance.aiim.datasets && Context.instance.aiim.datasets.units;
    if(!units) return false;

    const layer = units.layer2D;
    if(!layer) return false;

    const fields = layer.fields;
    if(aiimUtil.findField(fields,FieldNames.RESERVATION_METHOD)) return true;
    return false;
  }

  unitHasScheduleEmail =()=> {
    const units = Context.instance.aiim.datasets && Context.instance.aiim.datasets.units;
    if(!units) return false;

    const layer = units.layer2D;
    if(!layer) return false;

    const fields = layer.fields;
    if(aiimUtil.findField(fields,FieldNames.SCHEDULE_EMAIL)) return true;
    return false;
  }

  handleOffice365=(event)=>{
    Topic.publish(Topic.RenderSidebar, {});
    Topic.publish(Topic.Configurator_RenderSteps);
    Office365.getInstance().updateAppId(this.state.appId);
    let stateParams = {};
    this.whenByOffice365Activated(stateParams);
    this.setState(stateParams)
    this.closeBookWorkspacePanel();
    Topic.publish(Topic.ReloadWorkspace, {});
  }

  // ___handleOffice365=(event)=>{
  //   Topic.publish(Topic.RenderSidebar, {});
  //   // when we switch to office365 initialise invalidWorkspaceConfig to true;
  //   // if the user inputs an appid we will set it to false
  //   // Context.instance.session.invalidWorkspaceConfig = true;
  //   Topic.publish(Topic.Configurator_RenderSteps);
  //   if(!this.state.appId) Context.instance.session.invalidWorkspaceConfig = true;
  //   else Context.instance.session.invalidWorkspaceConfig = false;
  //
  //   if(event && event.target && event.target.checked) {
  //     const cfg = this.props.cfg;
  //     if(this.state.appId) cfg.getConfigurable("workspaceReservation").enableOfficeHoteling = true;
  //     cfg.getConfigurable("workspaceReservation").enabled = true;
  //     cfg.getConfigurable("workspaceReservation").reservationType = "office365";
  //     cfg.getConfigurable("workspaceReservation").reservationLayerId = null;
  //     cfg.getConfigurable("workspaceReservation").appId = this.state.appId;
  //     cfg.getConfigurable("workspaceReservation").isSingleTenant = this.state.isSingleTenant;
  //     cfg.getConfigurable("workspaceReservation").tenantId = this.state.tenantId;
  //     Office365.getInstance().updateAppId(this.state.appId);
  //     this.setState({
  //       optionSelected: "office365",
  //       hotelBookingOffice365 : true
  //     });
  //     this.closeBookWorkspacePanel();
  //     Topic.publish(Topic.ReloadWorkspace, {});
  //   }
  // }

  handleInformationModel=(event)=>{
    Topic.publish(Topic.RenderSidebar, {});
    Topic.publish(Topic.Configurator_RenderSteps);
    let stateParams = {};
    this.whenByReservationsLayerActivated(stateParams);
    this.setState(stateParams)
    this.closeBookWorkspacePanel();
    Topic.publish(Topic.ReloadWorkspace, {});
  }

  // handleInformationModel=(event)=>{
  //   Topic.publish(Topic.RenderSidebar, {});
  //   let lyrId;
  //   Topic.publish(Topic.Configurator_RenderSteps);
  //
  //
  //   if(this.state.reservationsLyrId) lyrId = this.state.reservationsLyrId;
  //   if(event && event.target && event.target.checked) {
  //     const cfg = this.props.cfg;
  //     if(this.state.hotelBooking) cfg.getConfigurable("workspaceReservation").enableOfficeHoteling = true;
  //     else cfg.getConfigurable("workspaceReservation").enableOfficeHoteling = false;
  //     cfg.getConfigurable("workspaceReservation").reservationType = "esri";
  //     cfg.getConfigurable("workspaceReservation").reservationLayerId = lyrId;
  //     cfg.getConfigurable("workspaceReservation").appId = null;
  //     cfg.getConfigurable("workspaceReservation").isSingleTenant = false;
  //     cfg.getConfigurable("workspaceReservation").tenantId = null;
  //     let stateParams = {
  //       optionSelected: "esri",
  //       reservationsLyrId: lyrId
  //     }
  //     let wsInfo = this.workspaceInfo;
  //     if (wsInfo && wsInfo.canAutoEnableReservations) {
  //       cfg.getConfigurable("workspaceReservation").enableOfficeHoteling = true;
  //       stateParams.hotelBooking = true;
  //       if (wsInfo.unitsHasReservationMethod) {
  //         cfg.getConfigurable("workspaceReservation").enableMeetingRooms = true;
  //         stateParams.meetingRooms = true;
  //       } else {
  //         cfg.getConfigurable("workspaceReservation").enableMeetingRooms = false;
  //         stateParams.meetingRooms = false;
  //       }
  //       Context.instance.session.invalidWorkspaceConfig = true;
  //     } else {
  //       cfg.getConfigurable("workspaceReservation").enableOfficeHoteling = false;
  //       cfg.getConfigurable("workspaceReservation").enableMeetingRooms = false;
  //       stateParams.hotelBooking = false;
  //       stateParams.meetingRooms = false;
  //       Context.instance.session.invalidWorkspaceConfig = true;
  //     }
  //     this.setState(stateParams)
  //     this.closeBookWorkspacePanel();
  //     Topic.publish(Topic.ReloadWorkspace, {});
  //   }
  //
  // }

  handleChange = (event)=> {
    const name = event.target.name;
    const cfg = this.props.cfg;
    const activeKey = (name === "hotelBooking" ) ? "bookWorkspace" : name;

    if (this.state.optionSelected === "office365" && name === "hotelBooking") {
      this.setState({
        hotelBookingOffice365: !this.state.hotelBookingOffice365
      }, ()=> {
        cfg.getConfigurable("workspaceReservation").enableOfficeHoteling = this.state.hotelBookingOffice365;
        Topic.publish(Topic.ReloadWorkspace, {})
      })
    } else if (this.state.optionSelected === "esri" && name === "hotelBooking") {
      this.setState({
        hotelBooking: !this.state.hotelBooking
      }, ()=> {
        if(this.state.hotelBooking && this.unitLyrHasAreaID()) {
          cfg.getConfigurable("workspaceReservation").enableOfficeHoteling = true;
        }else  cfg.getConfigurable("workspaceReservation").enableOfficeHoteling = false;
        Topic.publish(Topic.ReloadWorkspace, {})
      })
    }
    else if(name === "meetingRooms") {
      this.setState({
        meetingRooms: !this.state.meetingRooms
      }, ()=> {
        if(this.state.meetingRooms && this.unitLyrHasAreaID() && this.unitLyrHasReservationMethod()) {
          cfg.getConfigurable("workspaceReservation").enableMeetingRooms = true;
        } else cfg.getConfigurable("workspaceReservation").enableMeetingRooms = false;
        Topic.publish(Topic.ReloadWorkspace, {});
      })
    }

    this.closeBookWorkspacePanel(activeKey);
  }

  renderCheckboxes =()=> {
    if(!this._mounted) return;

    const i18n = Context.instance.i18n;
    const hasReservationsLayer = this.state.hasReservationsLayer;
    const isLayerEditable = this.state.isLayerEditable;
    const canUserEdit = this.state.canUserEdit;

    if(!hasReservationsLayer || !isLayerEditable || !canUserEdit) {
      let error;
      if(!hasReservationsLayer) error = i18n.configurator.officeHoteling.reservationType.noValidReservationLyr;
      else if (!isLayerEditable) error = i18n.configurator.officeHoteling.reservationType.notEditable;
      else error = i18n.configurator.officeHoteling.reservationType.userCannotEdit;
      return (
        <p className="i-hotel-config i-issue" style={{fontSize: "small"}}>
          {error}
        </p>
      )
    } else {
      let errorMsgHotel, errorMsgMeetingRooms;

      if (this.state.hotelBooking){
        if(!this.unitLyrHasAreaID()) {
          Context.instance.session.invalidWorkspaceConfig = true;
          errorMsgHotel = i18n.configurator.officeHoteling.reservationType.missingUnitsLyrReqFields;
        } else Context.instance.session.invalidWorkspaceConfig = false;
      }

      if (this.state.meetingRooms) {
        if(!this.unitLyrHasAreaID() || !this.unitLyrHasReservationMethod()) {
          Context.instance.session.invalidWorkspaceConfig = true;
          errorMsgMeetingRooms = i18n.configurator.officeHoteling.reservationType.missingUnitsLyrReqFields;
        } else {
          Context.instance.session.invalidWorkspaceConfig = false;
        }
      }

      return (
        <div className="i-hoteling-appid" style={{marginTop: '1.5rem'}}>
          <div>
            <div key="header" className={CSS.formGroupHeader} style={{marginTop: '1.5rem'}}>
              <FormControlLabel
                className="i-appid-label"
                htmlFor="configurator-office-appid"
              >{i18n.configurator.officeHoteling.workspaceOptions.caption}
              </FormControlLabel>
              <HelpTip text={i18n.configurator.officeHoteling.workspaceOptions.helpTip}/>
            </div>
            <div className="i-radio-item-hotelBookOptions">
              <ul className="i-form-legend-hotelBookOptions">
                <li className="i-radio-item-hotelBookOptions">
                  <input type="checkbox"
                    className="i-hoteling-checkbox-row"
                    name="hotelBooking"
                    checked={this.state.hotelBooking}
                    onChange={this.handleChange}
                  />
                  {i18n.configurator.officeHoteling.workspaceOptions.newofficeHoteling}
                  {this.state.hotelBooking && (
                    <p className="i-hotel-config i-issue"> {errorMsgHotel} </p>
                )}
                </li>

                <li className="i-radio-item-hotelBookOptions">
                  <input type="checkbox"
                    className="i-hoteling-checkbox-row"
                    name="meetingRooms"
                    checked={this.state.meetingRooms}
                    onChange={this.handleChange}/>
                  {i18n.configurator.officeHoteling.workspaceOptions.meetingRooms}
                  {this.state.meetingRooms && (
                    <p className="i-hotel-config i-issue"> {errorMsgMeetingRooms} </p>
                  )}
                </li>

              </ul>
            </div>
          </div>
          </div>
      )
    }
  }

  onChangeEnabled = (evt) => {
    const checked = !!evt.target.checked;
    const cfg = this.props.cfg;
    this.setState(() => {
      return {
        enabled: checked
      }
    });

    if(!checked) {
      cfg.getConfigurable("workspaceReservation").enabled = checked;
      this.setState({
        appId : null,
        reservationsLyrId : null,
        reservationsLyrTitle: null,
        hotelBookingOffice365: false,
        hotelBooking: false,
        meetingRooms: false

      })
      if(!checked) Context.instance.session.invalidWorkspaceConfig = false;
      cfg.getConfigurable("workspaceReservation").appId = null;
      cfg.getConfigurable("workspaceReservation").tenantId = null;
      cfg.getConfigurable("workspaceReservation").isSingleTenant = false;
      cfg.getConfigurable("workspaceReservation").reservationType = null;
      cfg.getConfigurable("workspaceReservation").reservationLayerId = null;
    }
    if(checked) this.init("enableWorkspaceReservarionClicked");
    Topic.publish(Topic.ReloadWorkspace, {});
  }

  onAppIdTextChange = (e) => {
    const cfg = this.props.cfg
    this.setState({
      appId: e.target.value
    })
    if(e.target.value) Context.instance.session.invalidWorkspaceConfig = false;
    else Context.instance.session.invalidWorkspaceConfig = true;
    cfg.getConfigurable("workspaceReservation").appId = e.target.value;

    this.props.cfg.getConfigurable("workspaceReservation").enabled = true;
    this.props.cfg.getConfigurable("workspaceReservation").reservationType = "office365"
    this.props.cfg.getConfigurable("workspaceReservation").enableOfficeHoteling = true;
    Topic.publish(Topic.ReloadWorkspace, {});
  }

  onAppIdTextBlur = (e) =>{
    Office365.getInstance().updateAppId(e.target.value);
    if(e.target.value) Context.instance.session.invalidWorkspaceConfig = false;
    else Context.instance.session.invalidWorkspaceConfig = true;

    this.props.cfg.getConfigurable("workspaceReservation").enabled = true;
    this.props.cfg.getConfigurable("workspaceReservation").reservationType = "office365"
    this.props.cfg.getConfigurable("workspaceReservation").enableOfficeHoteling = true;
    Topic.publish(Topic.ReloadWorkspace, {});
  }

  onTenantIdTextChange = (e) => {
    const cfg = this.props.cfg
    this.setState({
      tenantId: e.target.value
    })
    cfg.getConfigurable("workspaceReservation").tenantId = e.target.value;
  }

  onTenantIdTextBlur = (e) => {
    Office365.getInstance().updateTenantId(e.target.value);
    Topic.publish(Topic.ReloadWorkspace, {});
    //Topic.publish(Topic.ReloadViews, {});
  }

  onSingleTenantCheckChanged = (e) => {
    const checked = !this.state.isSingleTenant;

    const cfg = this.props.cfg
    cfg.getConfigurable("workspaceReservation").isSingleTenant = checked;

    this.setState({
      isSingleTenant: checked
    });

    if(cfg.getConfigurable("workspaceReservation").tenantId) {
      Office365.getInstance().updateTenantId(cfg.getConfigurable("workspaceReservation").tenantId);
      Topic.publish(Topic.ReloadWorkspace, {});
      //Topic.publish(Topic.ReloadViews, {});
    }
  }

  renderHeader() {
    const i18n = Context.instance.i18n;
    return (
      <div key="header" className={CSS.formGroupHeader}>
        <span className={CSS.formGroupName}
          >{i18n.configurator.officeHoteling.newcaption}</span>
        <HelpTip text={i18n.more.bookWorkspace.newhotelingHelpTip}/>
      </div>
    );
  }

  renderToggleSection() {
    const { enabled } = this.state;
    const i18n = Context.instance.i18n;
    const optionSelected = this.state.optionSelected;
    const unitHasScheduleEmail = this.unitHasScheduleEmail();

    if(optionSelected === "office365" && !unitHasScheduleEmail) {
      Context.instance.session.invalidWorkspaceConfig = true;
    }

    if(this.state.enabled) {
      return (
        <div key="enableOfficeHoteling" className={CSS.formGroup}>
        <label
          id={"cfg-officehoteling-enabled-label"}
          htmlFor={"cfg-officehoteling-enabled"}
          className={"i-flex-between"}
        >
          <div className={CSS.toggleLabel}>
            {i18n.configurator.officeHoteling.newsubCaption}
          </div>
          <ReactToggle
            id={"cfg-officehoteling-enabled"}
            checked={enabled}
            onChange={this.onChangeEnabled}
            icons={false} />
        </label>

          <div key="header" className={CSS.formGroupHeader} style={{marginTop: '1.5rem'}}>
            <FormControlLabel
              className="i-appid-label"
              htmlFor="configurator-office-appid"
            >
              {i18n.configurator.officeHoteling.reservationType.caption}
            </FormControlLabel>
            <HelpTip text={i18n.configurator.officeHoteling.reservationType.helpTip} />
          </div>
          <div className="i-radio-item-hotelBookOptions">
            <ul className="i-form-legend-hotelBookOptions">
              <li className="i-radio-item-hotelBookOptions">
                <input
                  type="radio"
                  name="bookworkspaceRadio"
                  value="office365"
                  checked={optionSelected === "office365"}
                  onChange={this.handleOffice365}
                /> {i18n.configurator.officeHoteling.reservationType.office365}

                {optionSelected === "office365" &&  !unitHasScheduleEmail &&
                  <p className="i-hotel-config i-issue">
                    {i18n.configurator.officeHoteling.reservationType.missingUnitsLyrReqFields}</p>}
              </li>
              <li className="i-radio-item-hotelBookOptions">
                <input
                  type="radio"
                  name="bookworkspaceRadio"
                  value="esri"
                  checked={optionSelected === "esri"}
                  onChange={this.handleInformationModel}
                /> {i18n.configurator.officeHoteling.reservationType.reservationLayer}
                {optionSelected === "esri" &&
                  <div>{this.state.reservationsLyrTitle}</div>}
              </li>
            </ul>
          </div>
      </div>
    )
  }else {
    return (
      <div key="enableOfficeHoteling" className={CSS.formGroup}>
        <label
          id={"cfg-officehoteling-enabled-label"}
          htmlFor={"cfg-officehoteling-enabled"}
          className={"i-flex-between"}
        >
          <div className={CSS.toggleLabel}>
            {i18n.configurator.officeHoteling.newsubCaption}
          </div>
          <ReactToggle
            id={"cfg-officehoteling-enabled"}
            checked={enabled}
            onChange={this.onChangeEnabled}
            icons={false} />
        </label>
      </div>
    )
  }
  }

  renderOffice365Sections() {
    const { enabled, isSingleTenant } = this.state;
    if (!enabled) {
      return null;
    }
    const appId = this.state.appId || "";
    const tenantId = this.state.tenantId || "";
    const i18n = Context.instance.i18n;

      return (
        <div>
          <div className="i-hoteling-appid" style={{marginTop: '1.5rem'}}>
            <FormControlLabel className="i-appid-label">
              {i18n.configurator.officeHoteling.workspaceOptions.newofficeHoteling}
            </FormControlLabel>
            <div className={CSS.formGroup}>
                <div key="header" className={CSS.formGroupHeader}>
                  <FormControlLabel
                    className="i-appid-label"
                    htmlFor="configurator-office-appid"
                  >
                    {i18n.more.bookWorkspace.appId}
                  </FormControlLabel>
                  <HelpTip text={i18n.more.bookWorkspace.newappIdHelpTip}/>
                </div>
                <div className="i--a">
                  <p>{i18n.more.bookWorkspace.appIdSubTitle}</p>
                </div>
                <TextField
                  id="configurator-office-appid"
                  placeholder={i18n.more.bookWorkspace.appIdPlaceholder}
                  value={appId}
                  onChange={this.onAppIdTextChange}
                  onBlur={this.onAppIdTextBlur}
                />
              </div>
              <div className="i-hoteling-tenantinfo">
                <Checkbox
                  checked={isSingleTenant}
                  onChange={this.onSingleTenantCheckChanged}
                >
                  {i18n.more.bookWorkspace.newtenantIdCheckbox}
                </Checkbox>
                <div className="i-hoteling-tenantid">
                  <div key="header2" className={CSS.formGroupHeader}>
                    <FormControlLabel
                      className="i-appid-label"
                      htmlFor="configurator-office-tenantid"
                    >
                      {i18n.more.bookWorkspace.tenantId}
                    </FormControlLabel>
                    <HelpTip text={i18n.more.bookWorkspace.newtenantIdHelptip}/>
                  </div>
                  <div className="i--a">
                      <p>{i18n.more.bookWorkspace.newtenantIdSubTitle}</p>
                  </div>
                  <TextField
                    id="configurator-office-tenantid"
                    placeholder={i18n.more.bookWorkspace.tenantIdPlaceholder}
                    value={tenantId}
                    onChange={this.onTenantIdTextChange}
                    onBlur={this.onTenantIdTextBlur}
                    disabled={!isSingleTenant}
                  />
                </div>
              </div>
            </div>
        </div>
      );
  }

  renderInformationModelSections =()=> {
    return this.renderCheckboxes();
  }

  render() {
    const optionSelected = this.state.optionSelected;
    let isOffice365 = false;
    if(optionSelected === "office365") isOffice365 = true;
    return (
      <div className={CSS.section}>
        {this.renderHeader()}
        {this.renderToggleSection()}
        {this.state.enabled &&
          (isOffice365 ? this.renderOffice365Sections() : this.renderInformationModelSections())}
      </div>
    );
  }

  whenByOffice365Activated = (stateParams,initType) => {
    const wsCfg = this.props.cfg.getConfigurable("workspaceReservation");
    //const wsInfo = this.workspaceInfo;

    let appId = null;
    let isSingleTenant = false;
    let tenantId = null;

    if (true) {
      appId = this.state.appId;
      isSingleTenant = this.state.isSingleTenant;
      tenantId = this.state.tenantId;
    }

    // TODO???
    // Office365.getInstance().updateAppId(this.state.appId);

    wsCfg.enabled = true;
    wsCfg.reservationType = "office365";
    wsCfg.appId = appId;
    wsCfg.isSingleTenant = isSingleTenant;
    wsCfg.tenantId = tenantId;
    wsCfg.reservationLayerId = null;

    stateParams.enabled = true;
    stateParams.optionSelected = "office365";
    stateParams.hotelBookingOffice365 = true;
    stateParams.appId = appId;
    stateParams.isSingleTenant = isSingleTenant;
    stateParams.tenantId = tenantId;
    //stateParams.reservationsLyrId = null; // TODO?

    if (wsCfg.appId) {
      wsCfg.enableOfficeHoteling = true;
      Context.instance.session.invalidWorkspaceConfig = false;
    } else {
      wsCfg.enableOfficeHoteling = false;
      Context.instance.session.invalidWorkspaceConfig = true;
    }
  }

  whenByReservationsLayerActivated = (stateParams,initType) => {
    const wsCfg = this.props.cfg.getConfigurable("workspaceReservation");
    const wsInfo = this.workspaceInfo;
    const lyrId = (wsInfo && wsInfo.reservationLayerId);

    // restoring a previously saved configuration
    let enableOfficeHotelingWasOff = false;
    let enableMeetingRoomsWasOff = false;
    if (initType === "componentMounted") {
      if (wsCfg.reservationType === "esri") {
        enableOfficeHotelingWasOff = !wsCfg.enableOfficeHoteling;
        enableMeetingRoomsWasOff = !wsCfg.enableMeetingRooms;
      }
    }

    wsCfg.enabled = true;
    wsCfg.reservationType = "esri";
    wsCfg.reservationLayerId = lyrId;
    wsCfg.appId = null;
    wsCfg.isSingleTenant = false;
    wsCfg.tenantId = null;

    stateParams.enabled = true;
    stateParams.optionSelected = "esri";
    stateParams.reservationsLyrId = lyrId;

    if (wsInfo.canAutoEnableReservations) {
      wsCfg.enableOfficeHoteling = true;
      stateParams.hotelBooking = true;
      if (wsInfo.unitsHasReservationMethod) {
        wsCfg.enableMeetingRooms = true;
        stateParams.meetingRooms = true;
      } else {
        wsCfg.enableMeetingRooms = false;
        stateParams.meetingRooms = false;
      }

      if (enableOfficeHotelingWasOff) {
        wsCfg.enableOfficeHoteling = false;
        stateParams.hotelBooking = false;
      }
      if (enableMeetingRoomsWasOff) {
        wsCfg.enableMeetingRooms = false;
        stateParams.meetingRooms = false;
      }

      Context.instance.session.invalidWorkspaceConfig = false;
    } else {
      wsCfg.enableOfficeHoteling = false;
      stateParams.hotelBooking = false;
      wsCfg.enableMeetingRooms = false;
      stateParams.meetingRooms = false;
      Context.instance.session.invalidWorkspaceConfig = true;
    }
  }

}

const mapStateToProps = (state) => {
  return {
    rdxSidebarActiveKey: Rdx.getValue(state,Rdx.Keys.SIDEBAR_ACTIVE_KEY),
  }
}

export default connect(mapStateToProps)(OfficeHoteling);
